import { createAsyncThunk } from "@reduxjs/toolkit";
import { City } from "@shared/lib/interfaces/city.interface";
import { setCities } from "./filtersSlice";

export const saveCity = createAsyncThunk(
    "filters/saveCity",
    async (city: City | undefined, thunkAPI) => {
        try {
            if (city) {
                localStorage.setItem("city", JSON.stringify(city));
                thunkAPI.dispatch(setCities([city]));
            } else {
                localStorage.removeItem("city");
                thunkAPI.dispatch(setCities([]));
            }
        } catch (e: unknown) {
            if (e instanceof Error) {
                return thunkAPI.rejectWithValue(e.message);
            } else {
                return thunkAPI.rejectWithValue("Произошла неизвестная ошибка");
            }
        }
    }
);